/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._flex_w8urc_157 {
  display: flex;
}

._justify-content-space-between_w8urc_161 {
  justify-content: space-between;
}

._tabular-nums_w8urc_165 {
  font-variant-numeric: tabular-nums;
}

@keyframes _show_w8urc_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Text styles */
._disabledRow_w8urc_178 {
  background-color: #f5f5f5;
  pointer-events: none;
  opacity: 0.6;
}

._ellipsis_w8urc_184 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

._newBulkPaymentsTableContainer_w8urc_190 ._headerContainer_w8urc_190 {
  display: flex;
  justify-content: space-between;
}
._newBulkPaymentsTableContainer_w8urc_190 ._paymentTypeContainer_w8urc_194 {
  margin: 24px 0;
}
._newBulkPaymentsTableContainer_w8urc_190 ._paymentTypeContainer_w8urc_194 ._paymentTypeRadio_w8urc_197 {
  margin-top: 8px;
}
._newBulkPaymentsTableContainer_w8urc_190 ._paymentTypeContainer_w8urc_194 ._paymentTypeRadio_w8urc_197 .ant-radio-button-wrapper {
  border-radius: 6px !important;
  margin-right: 8px;
  border: 1px solid #d9d9d9;
}
._newBulkPaymentsTableContainer_w8urc_190 ._paymentTypeContainer_w8urc_194 ._paymentTypeRadio_w8urc_197 .ant-radio-button-wrapper:first-child {
  border-left: 1px solid #d9d9d9;
}
._newBulkPaymentsTableContainer_w8urc_190 ._paymentTypeContainer_w8urc_194 ._paymentTypeRadio_w8urc_197 .ant-radio-button-wrapper:not(:first-child):before {
  display: none;
}
._newBulkPaymentsTableContainer_w8urc_190 ._footerContainer_w8urc_211 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background-color: #f8f9fa;
  border: 1px solid #e6e8eb;
  border-top: none;
  border-radius: 0 0 8px 8px;
  margin-top: -1px;
}
._newBulkPaymentsTableContainer_w8urc_190 ._footerContainer_w8urc_211 ._footerLeft_w8urc_222 {
  display: flex;
  align-items: center;
  gap: 8px;
}
._newBulkPaymentsTableContainer_w8urc_190 ._footerContainer_w8urc_211 ._footerLeft_w8urc_222 ._checkIcon_w8urc_227 {
  color: #52c41a;
  font-size: 16px;
}
._newBulkPaymentsTableContainer_w8urc_190 ._footerContainer_w8urc_211 ._footerLeft_w8urc_222 ._selectedText_w8urc_231 {
  font-weight: 500;
  color: #262626;
  font-size: 14px;
}
._newBulkPaymentsTableContainer_w8urc_190 ._footerContainer_w8urc_211 ._footerRight_w8urc_236 ._totalText_w8urc_236 {
  font-weight: 600;
  color: #262626;
  font-size: 14px;
}